<script>
export default {
  props: {
    roomName: String,
    lastChat: String,
    lastChatTime: String,
    isActive: Boolean,
    isOnline: Boolean,
    chatNotification: Number,
    userAvatar: String,
  },
}
</script>
<template>
  <!-- chat room card view -->
  <div
    class="w-100 d-flex px-1 py-1 hoverable"
    :class="{ 'bg-primary text-white': isActive }"
    @click="$emit('chat-room-click')"
  >
    <!-- avatar -->
    <div class="avatar avatar-border h-100 d-flex align-items-center">
      <img
        :src="
          userAvatar !== 'default' &&
          $isNotEmpty(userAvatar) &&
          userAvatar !== ''
            ? userAvatar
            : require('@/assets/images/placeholder/no-image.jpg')
        "
        height="42"
        width="42"
      />
      <span v-if="isOnline" class="avatar-status-online" />
      <span v-else class="avatar-status-offline" />
    </div>
    <div class="d-flex flex-column ml-1 w-100 justify-content-center">
      <!-- username and last message time -->
      <div class="d-flex justify-content-between">
        <p class="m-0">
          <strong>{{ roomName }}</strong>
        </p>
        <p
          class="text-smaller m-0"
          :class="{ 'text-muted': !isActive, 'text-white': isActive }"
        >
          {{ lastChatTime }}
        </p>
      </div>
      <!-- user latest chat -->
      <div
        class="d-flex justify-content-between align-items-center"
        style="margin-top: 7px"
      >
        <p
          class="m-0 text-small w-50"
          :class="{ 'text-muted': !isActive, 'text-white': isActive }"
        >
          {{ lastChat.length > 20 ? `${lastChat.substr(0, 20)}...` : lastChat }}
        </p>
        <span
          v-if="chatNotification > 0"
          class="circle-size bg-danger rounded-circle"
        >
          <p class="text-white text-smaller d-flex justify-content-center">
            {{ chatNotification }}
          </p>
        </span>
      </div>
    </div>
  </div>
</template>

<style>
.text-smaller {
  font-size: smaller;
}

.text-small {
  font-size: small;
}

.p-top-small {
  padding-top: 2px;
}

.circle-size {
  width: 20px !important;
  height: 20px !important;
}

.hoverable:hover {
  background-color: rgba(211, 211, 211, 0.243);
  cursor: pointer;
}
</style>
